import { formatThoughtForSecondsLabel } from '@/services/chatApi'
import { buildCreateAgentQuestionPayload } from './buildCreateAgentQuestionPayload.js'

export function buildAgentQuestionAssistantMessagePatch(thinkingStartedAtMs) {
  const agentQuestion = buildCreateAgentQuestionPayload()
  const endedAt = Date.now()
  return {
    text: '',
    agentQuestion,
    agentBrand: agentQuestion.agentBrand,
    agentName: agentQuestion.agentName,
    thoughtSummary: formatThoughtForSecondsLabel(thinkingStartedAtMs, endedAt),
    createdAt: endedAt,
  }
}
